module.exports = __webpack_public_path__ + "img/d187fd8.png";